import { useSoyuzFlag } from '@spotahome/soyuz/client';

import { EcommerceManagerFactory } from './ecommerceManagerFactory';

let ecommerceManagerFactoryInstance;

// Hook to use experiment/flags inside
export const useEcommerceManagerFactory = ({ sendInHouseAnalytics } = {}) => {
  ecommerceManagerFactoryInstance =
    ecommerceManagerFactoryInstance ||
    EcommerceManagerFactory({
      sendInHouseAnalytics
    });

  return ecommerceManagerFactoryInstance;
};
